import { render } from "./protectionItemCreate.vue?vue&type=template&id=3f16be11&scoped=true"
import script from "./protectionItemCreate.vue?vue&type=script&lang=js"
export * from "./protectionItemCreate.vue?vue&type=script&lang=js"

import "./protectionItemCreate.vue?vue&type=style&index=0&id=3f16be11&scoped=true&lang=css"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f16be11"]])

export default __exports__